import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Функция для извлечения даты из названия файла
export function extractDateFromFilename(filename) {
  if (!filename) return 'невідомий період';
  
  // Ищем паттерн MM.YYYY в названии файла
  const match = filename.match(/(\d{2})\.(\d{4})/);
  if (match) {
    const month = parseInt(match[1]);
    const year = parseInt(match[2]);
    
    const monthNames = [
      'січень', 'лютий', 'березень', 'квітень', 'травень', 'червень',
      'липень', 'серпень', 'вересень', 'жовтень', 'листопад', 'грудень'
    ];
    
    // Проверяем корректность месяца
    if (month >= 1 && month <= 12) {
      return `${monthNames[month - 1]} ${year}`;
    }
  }
  
  return 'невідомий період';
}
